import { render, staticRenderFns } from "./TheThgPartnerList.vue?vue&type=template&id=684369fa&scoped=true"
import script from "./TheThgPartnerList.vue?vue&type=script&lang=ts"
export * from "./TheThgPartnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684369fa",
  null
  
)

export default component.exports